export type TeamWorkspaceImportPreviewIssue = {
  code: string;
  modelHandle?: string;
  message?: string;
};

export type TeamWorkspaceImportPreviewPage = {
  path: string;
  modelHandle: string;
  issues: TeamWorkspaceImportPreviewIssue[];
};

const isModelMissing = (page: TeamWorkspaceImportPreviewPage) =>
  page.issues.some((issue) => issue.code === "MODEL_NOT_FOUND");

const fieldMappingCount = (page: TeamWorkspaceImportPreviewPage) =>
  page.issues.filter((issue) => issue.code === "FIELD_MAPPING").length;

export const formatTeamWorkspaceImportPageDescription = (
  page: TeamWorkspaceImportPreviewPage,
): string => {
  if (isModelMissing(page)) {
    return `${page.path} · model "${page.modelHandle}" missing`;
  }

  const unmappedFields = fieldMappingCount(page);
  if (unmappedFields === 1) {
    return `${page.path} · model ${page.modelHandle} · 1 field was not found`;
  }
  if (unmappedFields > 1) {
    return `${page.path} · model ${page.modelHandle} · ${unmappedFields} fields were not found`;
  }

  return `${page.path} · model ${page.modelHandle}`;
};

export const formatTeamWorkspaceImportIssueSummary = (
  pages: TeamWorkspaceImportPreviewPage[],
): string | undefined => {
  const missingModels = pages.filter(isModelMissing).length;
  const fieldPages = pages.filter(
    (page) => !isModelMissing(page) && fieldMappingCount(page) > 0,
  ).length;

  const parts: string[] = [];
  if (missingModels === 1) parts.push("1 model missing");
  if (missingModels > 1) parts.push(`${missingModels} models missing`);
  if (fieldPages === 1) parts.push("1 page has unmapped fields");
  if (fieldPages > 1) parts.push(`${fieldPages} pages have unmapped fields`);
  return parts.length ? parts.join(" · ") : undefined;
};
